import React, { Component } from 'react';
import { connect } from 'react-redux';
import VerificationCode from '../../../../components/VerificaionCode';
import LoadingView from '../../../../components/LoadingView';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import {
  INIT_VERIFY_ERROR_CODE,
  verifyCode,
} from '../../actions/changeContactAction';
import { submitResetPassword } from '../../actions/customerResetPasswordAction';
import { submitResetUserName } from '../../actions/customerResetUserNameAction';
import { sendOtp } from '../../actions/customerProfileVerifyAction';
import { goto } from '../../../../actions/historyActions';
import { getCustomerProfileCurrentUpdateKey } from '../../selectors/customerProfileResetUNOrPWSelectors';
import {
  getCustomerProfileUsenameConfig,
  getCustomerProfileUsenameEmail,
  getCustomerProfileUsenameMobile,
  getCustomerProfileUsenameCurTab,
  getCustomerProfileUsenameSubmitLoading,
} from '../../selectors/customerProfileResetUsenameSelectors';
import {
  getCustomerProfilePasswordConfig,
  getCustomerProfilePasswordSubmitLoading,
  getCustomerProfilePasswordValue,
} from '../../selectors/customerProfileResetPasswordSelectors';
import { getVerifyLoading } from '../../selectors/changeContactSelector';
import { resolveLocalizedText, getLoginId, isApp } from '../../../../utils';
import {
  RESET_USER_NAME_KEY,
  RESET_PASSWORD_KEY,
  FEATURE_NAME_USER_NAME,
  FEATURE_NAME_PASSWORD,
  RESET_USER_NAME_EMAIL_TYPE,
  RESET_USER_NAME_MOBILE_TYPE,
  RESET_USER_NAME_EMAIL_DEFAULT_ERROR_CODE,
  RESET_PASSWORD_DEFAULT_ERROR_CODE,
  RESET_USERNAME_FEATURE_ID,
  RESET_PASSWORD_FEATURE_ID,
} from '../../constants/constants';
import { getToken } from '../../../../selectors/authSelectors';
import { select } from '../../../../stores';
import './style.scss';
import {
  TrackUpdateContactSuccessContent,
  TrackUpdateContactSuccessAction,
  trackUpdateContactSuccess,
} from '../../../../utils/generalGaEventAnalytics';
import { getErrorCode, getErrorCodeFieldLabel } from '../../utils';
import { getChangeContactErrorCode } from '../../selectors/changeContactSelector';
import { getForceLogoutFlagDeepLink } from '../../selectors/customerProfileSelectors';
import { updateForceLogoutFlag } from '../../../../actions/authActions';
import { t } from '../../../../locales';
import { ChangeContactView } from '../../components/ChangeContactView';
import browserHistory from '../../../../stores/browserHistory';
import { extractCountryCode } from '../../../../../src/utils/common';
export interface CustomerProfileVerifyContainerProps {
  isSubmitLoading: boolean;
  curUpdateKey: string;
  title: string;
  email: string;
  mobile: string;
  curTab: string;
  forceLogoutDeepLink: string;
  onVerifyCode: (
    feature: string,
    code: string,
    defaultErrorCode: string,
    featureId: string,
    callback: () => void,
  ) => void;
  onSubmitResetPassword: (params?: any) => void;
  onSubmitResetUserName: (params?: any) => void;
  onSendOtp: (params?: any) => void;
  errorMsg: string;
  init: () => void;
  onUpdateForceLogoutFlag: (isForceLogout: boolean) => void;
  stepContext: any;
  password: string;
  mobileWithCountryCode: string;
  formattedLoginId: string;
}

export interface CustomerProfileVerifyContainerState {}

export class CustomerProfileVerifyContainer extends Component<
  CustomerProfileVerifyContainerProps,
  CustomerProfileVerifyContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
    this.onValidate = this.onValidate.bind(this);
    this.onReSend = this.onReSend.bind(this);
  }

  componentDidMount() {
    this.props.init();
    const { curUpdateKey } = this.props;
    !curUpdateKey && goto('emma-customer-profile-resetusenameorpassword');
  }

  onValidate(otp: string) {
    const {
      forceLogoutDeepLink,
      onUpdateForceLogoutFlag,
      onVerifyCode,
      curUpdateKey,
      onSubmitResetUserName,
      onSubmitResetPassword,
    } = this.props;
    const featureName =
      curUpdateKey === RESET_USER_NAME_KEY
        ? FEATURE_NAME_USER_NAME
        : curUpdateKey === RESET_PASSWORD_KEY
        ? FEATURE_NAME_PASSWORD
        : '';
    const defaultErrorCode =
      curUpdateKey === RESET_USER_NAME_KEY
        ? RESET_USER_NAME_EMAIL_DEFAULT_ERROR_CODE
        : curUpdateKey === RESET_PASSWORD_KEY
        ? RESET_PASSWORD_DEFAULT_ERROR_CODE
        : '';
    const featureId =
      curUpdateKey === RESET_USER_NAME_KEY
        ? RESET_USERNAME_FEATURE_ID
        : curUpdateKey === RESET_PASSWORD_KEY
        ? RESET_PASSWORD_FEATURE_ID
        : '';
    onVerifyCode(featureName, otp, defaultErrorCode, featureId, () => {
      if (curUpdateKey === RESET_USER_NAME_KEY) {
        onSubmitResetUserName({
          otp,
          defaultErrorCode,
          callBack: () => {
            if (isApp()) {
              EmmaFactory.createInstance().then((e) => {
                e.instance.goTo(forceLogoutDeepLink);
              });
            } else {
              onUpdateForceLogoutFlag(true);
            }
            goto('emma-customer-profile-resetusename-confirm');
          },
        });
      } else if (curUpdateKey === RESET_PASSWORD_KEY) {
        onSubmitResetPassword({
          otp,
          defaultErrorCode,
          callBack: () => {
            goto('emma-customer-profile-resetpassword-confirm');
          },
        });
      }
    });
  }

  onReSend(params: any) {
    const { email, mobile, password, curUpdateKey, curTab, onSendOtp, init } =
      this.props;
    init();
    if (curUpdateKey === RESET_USER_NAME_KEY) {
      onSendOtp({
        featureName: FEATURE_NAME_USER_NAME,
        email: curTab === RESET_USER_NAME_EMAIL_TYPE ? email : null,
        mobile: curTab === RESET_USER_NAME_MOBILE_TYPE ? mobile : null,
        userId:
          curTab === RESET_USER_NAME_EMAIL_TYPE
            ? email
            : RESET_USER_NAME_MOBILE_TYPE
            ? mobile
            : null,
      });
    } else if (curUpdateKey === RESET_PASSWORD_KEY) {
      const token = select(getToken);
      const loginId = getLoginId(token);
      const isEmail = loginId.includes('@');
      onSendOtp({
        featureName: FEATURE_NAME_PASSWORD,
        email: isEmail ? loginId : null,
        mobile: !isEmail ? loginId : null,
        password,
      });
    }
  }

  renderText = (curUpdateKey: string, curTab: string) => {
    if (curUpdateKey === RESET_USER_NAME_KEY) {
      return curTab === RESET_USER_NAME_EMAIL_TYPE
        ? t('OTP_EMAIL_TEXT')
        : t('OTP_TEXT');
    } else if (curUpdateKey === RESET_PASSWORD_KEY) {
      const token = select(getToken);
      const loginId = getLoginId(token);
      const isEmail = loginId.includes('@');
      return isEmail ? t('OTP_EMAIL_TEXT') : t('OTP_TEXT');
    }
    return t('OTP_TEXT');
  };

  onGoBack = () => {
    browserHistory.goBack();
  };

  render() {
    const {
      isSubmitLoading,
      title,
      errorMsg,
      curUpdateKey,
      curTab,
      stepContext,
      email,
      mobileWithCountryCode,
      formattedLoginId,
    } = this.props;
    return isSubmitLoading ? (
      <LoadingView />
    ) : (
      <div className="customer-profile-verify">
        <ChangeContactView
          onGoBack={this.onGoBack}
          pageName={title ? resolveLocalizedText(title) : ''}
          stepContext={stepContext}
          activeIndex={1}
        >
          <div className="customer-profile-verify-container emma-stylesheet-grid-system">
            <div className="customer-profile-verify-container-verification-code">
              <VerificationCode
                newContact={
                  curUpdateKey === RESET_PASSWORD_KEY
                    ? formattedLoginId
                    : curTab === RESET_USER_NAME_EMAIL_TYPE
                    ? email
                    : mobileWithCountryCode
                }
                onValidate={this.onValidate}
                onReSend={this.onReSend}
                errorMsg={errorMsg}
                text={this.renderText(curUpdateKey, curTab)}
              />
            </div>
          </div>
        </ChangeContactView>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const resetUsenameLabels = getCustomerProfileUsenameConfig(state);
    const curUpdateKey = getCustomerProfileCurrentUpdateKey(state);
    const userNameTitle =
      resetUsenameLabels && resetUsenameLabels.title
        ? resolveLocalizedText(resetUsenameLabels.title)
        : '';
    const resetPasswordLabels = getCustomerProfilePasswordConfig(state);
    const passWordTitle =
      resetPasswordLabels && resetPasswordLabels.title
        ? resolveLocalizedText(resetPasswordLabels.title)
        : '';
    const title =
      curUpdateKey === RESET_USER_NAME_KEY
        ? userNameTitle
        : curUpdateKey === RESET_PASSWORD_KEY
        ? passWordTitle
        : '';
    const email = getCustomerProfileUsenameEmail(state);
    const mobile = getCustomerProfileUsenameMobile(state);
    const { countryCode, mobileNumber: extractedMobileNumber } =
      extractCountryCode(mobile);
    const token = select(getToken);
    const loginId = getLoginId(token);
    const isEmail = loginId.includes('@');
    const { countryCode: loginIdCountryCode, mobileNumber: loginIdMobile } =
      extractCountryCode(loginId);
    const formattedLoginId = isEmail
      ? loginId
      : `+${loginIdCountryCode} ${loginIdMobile}`;

    const password = getCustomerProfilePasswordValue(state);
    const curTab = getCustomerProfileUsenameCurTab(state);
    const verifyErrorCode = getChangeContactErrorCode(state);
    const isUserNameSubmitLoading =
      getCustomerProfileUsenameSubmitLoading(state);
    const isPasswordSubmitLoading =
      getCustomerProfilePasswordSubmitLoading(state);
    const isVerifyLoading = getVerifyLoading(state);
    const forceLogoutDeepLink = getForceLogoutFlagDeepLink(state);
    const stepContext =
      resetUsenameLabels && resetUsenameLabels.resetUsernameStepContext
        ? resolveLocalizedText(resetUsenameLabels.resetUsernameStepContext)
        : '';

    let errorMsg = '';
    if (verifyErrorCode != '') {
      const errorCode = getErrorCode(verifyErrorCode, state);
      errorMsg = getErrorCodeFieldLabel(errorCode, 'title');
    }

    return {
      title,
      isSubmitLoading:
        isVerifyLoading || isUserNameSubmitLoading || isPasswordSubmitLoading,
      curUpdateKey,
      formattedLoginId,
      email,
      mobile,
      mobileWithCountryCode: `+${countryCode} ${extractedMobileNumber}`,
      curTab,
      errorMsg,
      forceLogoutDeepLink,
      stepContext,
      password,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onVerifyCode: (
        featureName: string,
        otp: string,
        defaultErrorCode: string,
        featureId: string,
        callback: () => void,
      ) =>
        dispatch(
          verifyCode({
            featureName,
            otp,
            defaultErrorCode,
            featureId,
            callback,
          }),
        ),
      onSendOtp: (params: any) => dispatch(sendOtp(params)),
      onSubmitResetPassword: (params?: any) =>
        dispatch(submitResetPassword(params)),
      onSubmitResetUserName: (params?: any) =>
        dispatch(submitResetUserName(params)),
      onUpdateForceLogoutFlag: (isForceLogout: boolean) =>
        dispatch(updateForceLogoutFlag(isForceLogout)),
      init: () => dispatch({ type: INIT_VERIFY_ERROR_CODE }),
    };
  }
}

export default connect(
  CustomerProfileVerifyContainer.mapStateToProps,
  CustomerProfileVerifyContainer.mapDispatchToProps,
)(CustomerProfileVerifyContainer);
